import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsIssuuCatalogBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsIssuuCatalogBlockEntity
